<template>
  <div class="home">
    <h1>Home</h1>
    <p class="mt-4">
      <center>
        <v-btn :disabled="errors.any()" @click="logout" class="caption font-weight-light">Logout</v-btn>
        <v-btn
          :disabled="errors.any()"
          @click="updatePassword"
          class="caption font-weight-light"
        >Update Password</v-btn>
      </center>
    </p>
  </div>
</template>

<script>

export default {
  name: "home",
  data() {
    return {
      msg: "Welcome to the AddClarity App!"
    };
  },
  methods: {
    logout: function() {
      this.$firebase.auth.signOut().then(() => {
        this.$store.commit('user/setUserProfile', ['userID', ""]);
        this.$store.commit('user/setUserProfile', ['userLevel', ""]);
        this.$store.commit('user/setUserProfile', ['emailVerified', ""]);
        this.$store.commit('user/setUserProfile', ['sponsorID', ""]);
        this.$store.commit('user/setUserProfile', ['fullName', ""]);
        this.$router.push('/authentication/login');
      });
    },
    updatePassword: function() {
      this.$router.push('/authentication/update-password');
    }
  }
};
</script>
